export default __webpack_public_path__ + "assets/images/checkbox-checked-910d5e7d.svg";